import { render, staticRenderFns } from "./routeTripDetail.vue?vue&type=template&id=27665758"
import script from "./routeTripDetail.vue?vue&type=script&lang=js"
export * from "./routeTripDetail.vue?vue&type=script&lang=js"
import style0 from "./routeTripDetail.vue?vue&type=style&index=0&id=27665758&prod&lang=scss&rel=stylesheet%2Fscss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports